// ES · Recorrido de novedades (TourNovedades.vue)
export const tourNovedades = {
  "title": "Novedades de WA Checkin",
  "kicker": "Novedades",
  "stepOf": "Paso {n} de {total}",
  "close": "Cerrar",
  "dontShow": "No mostrar de nuevo",
  "prev": "Anterior",
  "next": "Siguiente",
  "done": "Entendido",
  "steps": {
    "icons": {
      "title": "Iconos en tus reservas",
      "text": "Cada reserva del calendario y del listado muestra ahora pequeños iconos: peticiones a Recepción IA, llamadas, notas y si falta dinero por cobrar. Pasa el ratón por encima y verás el detalle sin abrir la reserva.",
      "cta": ""
    },
    "early": {
      "title": "Cobra la entrada anticipada",
      "text": "El early check-in ya puede tener precio. El agente IA pregunta la hora de llegada, calcula el coste y envía el enlace de pago. Al pagarse, se confirma solo.",
      "cta": "Configúralo en Agente IA"
    },
    "reception": {
      "title": "Recepción IA",
      "text": "Todo lo que tus huéspedes piden al agente (entrar antes, salir más tarde, más noches, facturas, recados de llamada) llega a una sola bandeja. Apruebas, rechazas o priorizas con un clic y ves el importe de lo que se cobra.",
      "cta": "Abrir Recepción IA"
    },
    "translate": {
      "title": "Traducción en tiempo real",
      "text": "En el chat de cada reserva y en la bandeja de entrada, activa la traducción: lo que escribe el huésped te llega en tu idioma y, al pulsar Intro, ves primero tu mensaje traducido al suyo antes de enviarlo.",
      "cta": "Ir a mensajes"
    },
    "voice": {
      "title": "Llamadas con el agente de voz",
      "text": "Activa la recepción telefónica: el agente IA contesta las llamadas en el idioma de quien llama, resuelve dudas, envía el enlace de reserva y te deja un resumen de cada llamada.",
      "cta": "Activar las llamadas"
    }
  },
  "demo": {
    "iconsTipTitle": "Recepción IA",
    "iconsTipEarly": "Early check-in",
    "iconsTipPending": "Pendiente:",
    "paid": "Pagada",
    "earlyGuest": "¿Podemos entrar a las 11:00?",
    "earlyAgent": "¡Sí! La entrada a las 11:00 cuesta 30 €. Puedes pagarla aquí:",
    "earlyPaid": "Pagada · confirmada",
    "rx": {
      "early": "Early check-in",
      "late": "Late checkout",
      "extend": "Alargar estancia"
    },
    "pending": "Pendiente",
    "confirmed": "Confirmada",
    "trGuestOrig": "What time can we pick up the keys?",
    "trGuestMine": "¿A qué hora podemos recoger las llaves?",
    "trMine": "A partir de las 15:00, te esperamos",
    "trTheirs": "From 3 pm, we look forward to seeing you",
    "voiceSummaryTitle": "Resumen de la llamada",
    "voiceSummary": "Preguntó por el parking y reservó 2 noches. Enlace de reserva enviado por WhatsApp."
  }
};
